module.exports = __webpack_public_path__ + "static/img/bg-m-0614-bottom.b7ae43f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-m-0614-bottom.jpg
// module id = IZx/
// module chunks = 1